import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}
export function PageHeader({
  title,
  subtitle,
  className = ''
}: PageHeaderProps) {
  return <div className={`relative bg-lavande py-16 md:py-28 overflow-hidden ${className}`} data-id="element-542" data-mp="kt1edb8yae93">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-543" data-mp="prkw0zgih3vn" />
      <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/4 w-[300px] h-[300px] bg-brand-orange rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-544" data-mp="trd83m545s5r" />

      <div className="container relative z-10 text-center max-w-4xl mx-auto" data-id="element-545" data-mp="13jreis74zmy9">
        <h1 className="font-heading text-4xl md:text-6xl font-extrabold text-primary-dark mb-6 tracking-tight leading-[1.1]" data-id="element-546" data-mp="18hasdqzx9xpo">
          {title}
        </h1>
        {subtitle && <p className="text-xl md:text-2xl text-primary-dark/80 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-547" data-mp="1hi8ycetx8faw">
            {subtitle}
          </p>}
      </div>
    </div>;
}